import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const GoogleAds = () => {
  const pageData = {
    category: "GOOGLE ADS",
    title: "Google Ads Management",
    description: "Dominate search results and reach customers at the exact moment they're searching for your products or services. Our Google Ads experts create high-converting campaigns that maximize ROI across Search, Display, Shopping, and Performance Max.",

    features: [
      {
        title: "Search Intent Targeting",
        description: "Capture high-intent customers actively searching for your solutions with optimized search campaigns and negative keyword strategies."
      },
      {
        title: "Display & Banner Ads",
        description: "Build brand awareness and remarketing campaigns across Google's massive display network of 2+ million websites."
      },
      {
        title: "Google Shopping Campaigns",
        description: "Showcase your products with rich imagery and pricing directly in search results to drive qualified e-commerce traffic."
      },
      {
        title: "Performance Max Campaigns",
        description: "AI-powered campaigns that automatically optimize across all Google properties including Search, Display, YouTube, and Gmail."
      },
      {
        title: "Conversion Tracking & Attribution",
        description: "Advanced tracking setup to measure every conversion, phone call, and customer interaction for complete visibility."
      },
      {
        title: "Landing Page Optimization",
        description: "Create high-converting landing pages aligned with ad messaging to maximize Quality Score and conversion rates."
      }
    ],

    benefits: [
      {
        title: "Instant Visibility",
        description: "Appear at the top of Google search results immediately and capture demand as it happens."
      },
      {
        title: "High-Intent Traffic",
        description: "Reach users actively searching for your products or services with purchase-ready mindset."
      },
      {
        title: "Measurable ROI",
        description: "Track every click, conversion, and dollar spent with transparent reporting and analytics."
      },
      {
        title: "Flexible Budgeting",
        description: "Scale up or down based on performance with complete control over daily budgets and bidding."
      }
    ],

    process: [
      {
        title: "Account Audit & Keyword Research",
        description: "Analyze existing campaigns (if any) and conduct comprehensive keyword research to identify high-value opportunities."
      },
      {
        title: "Campaign Structure & Setup",
        description: "Build organized campaign architecture with tightly themed ad groups, compelling ad copy, and strategic bid strategies."
      },
      {
        title: "Launch & Monitor",
        description: "Deploy campaigns with proper tracking, conversion goals, and real-time monitoring for immediate optimization."
      },
      {
        title: "Test, Optimize & Scale",
        description: "Continuously test ad variations, refine targeting, adjust bids, and scale winning campaigns for maximum profitability."
      }
    ],

    relatedServices: [
      {
        title: "Meta Ads",
        description: "Expand reach with Facebook and Instagram advertising",
        link: "/services/paid-ads/meta-ads"
      },
      {
        title: "LinkedIn Ads",
        description: "Target B2B professionals with LinkedIn campaigns",
        link: "/services/paid-ads/linkedin-ads"
      },
      {
        title: "Landing Page Optimization",
        description: "Maximize conversions with optimized landing pages",
        link: "/services/web-development/custom-websites"
      }
    ],

    ctaText: "Ready to generate qualified leads and sales with Google Ads? Let's build your winning campaign strategy.",
    ctaLink: "/contact",
    parentLink: "/services/paid-ads",
    parentTitle: "Paid Ads"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Google Ads Services" 
                description="Learn more about our Google Ads services to grow your business online with Digi Network." 
                canonical="/paid-ads/google-ads" 
            />

    </>
  );
};

export default GoogleAds;
